import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const Message = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
  margin-bottom: 32px;
`;

export const DropdownWrapper = styled.div`
  margin-bottom: 64px;
`;
